export default function loadingMoreCol() {
  var page = 1
  var url = '/cms/wp-admin/admin-ajax.php'
  var btnMoreCol = document.querySelector('#btn-more-col')
  var category = document.querySelector('#hid-category').value
  var found_posts = document.querySelector('#hid-found_posts').value
  btnMoreCol.addEventListener('click', function() {
    if (page * 10 >= found_posts) {
      return false
    }
    page++
    btnMoreCol.classList.add('-is-loading')
    var formData = new FormData()
    formData.append('page', page)
    formData.append('cat', category)
    fetch(url + '?action=get_column_posts', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
      .then(data => {
          if (data.posts) {
              data.posts.forEach((item) => {
                  var post = '<a class="column__link group" href="' + item.permalink + '">'
                  post += '<div class="column__thumb">'
                  var img = '<?= home_url() ?>/assets/img/default.png'
                  if (img != '') {
                      img = item.img
                  }
                  post += '<img src="' + img + '" alt="">'
                  post += '</div>'
                  post += '<div class="column__link-inner">'
                  post += '<div class="column__read-block">'
                  post += '<div class="column__title">' + item.title + '</div>'
                  post += '<div class="column__read">' + item.content + '</div>'
                  post += '</div>'
                  post += '<div class="column__tag-block">'
                  if (item.cats != '') {
                      post += '<ul class="column__tag-list">'
                      item.cats.forEach((cat) => {
                        post += '<li class="column__tag">' + cat + '</li>'
                      })
                      post += '</ul>'
                  }
                  post += '<div class="column__date">' + item.date + '</div>'
                  post += '</div>'
                  post += '</div>'
                  post += '</a>'
                  document.getElementById('column__list').innerHTML += post
              })
              var displayed_posts = page * 10
              var p = displayed_posts < found_posts ? displayed_posts : found_posts
              document.getElementById('post_num').textContent = p
              if (p == found_posts) {
                  btnMoreCol.setAttribute('disabled', 'disabled')
              }
          }
      })
    .finally(() => {
      btnMoreCol.classList.remove('-is-loading')
    })
  })
}
